export default {
  "HitPaw Online Audio Converter": "HitPaw Online Audio Converter",
  "Convert audios to MP3, AAC, FLAC, WMA and more formats for free.": "Converteer gratis audio naar MP3, AAC, FLAC, WMA en meer formaten.",
  'HitPaw Online Image Converter': 'HitPaw Online Afbeeldingen Converter',
  'Convert images to JPG, PNG, BMP, TIFF and more formats for free.': 'Converteer afbeeldingen gratis naar JPG, PNG, BMP, TIFF en meer formaten.',
  'HitPaw Online Video Converter': 'HitPaw Online Video Converter',
  'Convert videos to any formats as your requirements.': "Converteer video's naar elk gewenst formaat.",
  'Add More Files': 'Meer bestanden toevoegen',
  'Convert to': 'Omzetten naar',
  'Ready': 'Klaar',
  'Converting': 'Omzetten',
  'Video': 'Video',
  'Audio': 'Audio',
  'Image': 'Afbeelding',
  'Retry': 'Opnieuw proberen',
  'Download All': 'Alles downloaden',
  'Download Desktop': 'Desktop downloaden',
  'Continue Editing': 'Doorgaan met bewerken',
  'Convert': 'Converteren',
  'Cut': 'Snijden',
  'Speed': 'Snelheid',
  'Crop & Rotate': 'Bijsnijden & roteren',
  'Resize': 'Formaat wijzigen',
  'Extract': 'Uittreksel',
  'Add Music': 'Muziek toevoegen',
  'Subtitles': 'Ondertitels',
  'Merge': 'Samenvoegen',
  'Watermark Remover': 'Watermerk verwijderen',
  'Add Watermark': 'Watermerk toevoegen',
  'Please select a file to use': 'Kies een bestand dat u wilt gebruiken {{work}}',
  'Batch Processing': 'Batch Processing',
};
